import { MINUTES_IN_HOUR, SECONDS_IN_HOUR } from "@dtm-frontend/shared/utils";
import { DmsCoordinates, HemisphereSign } from "../models/dms-coordinates-input.models";

export function convertDmsCoordinatesToDecimalDegrees(dms: DmsCoordinates): number {
    // NOTE: Degrees could be -0 for values lower than 1° in southern and western hemisphere, example:  0° 30' 15" S
    const sign: HemisphereSign = dms.degrees < 0 || Object.is(dms.degrees, -0) ? HemisphereSign.Negative : HemisphereSign.Positive;

    return dms.degrees + (dms.minutes / MINUTES_IN_HOUR) * sign + (dms.seconds / SECONDS_IN_HOUR) * sign;
}
